// src/Models/ticketModel.js
// -----------------------------------------------------------------------------
// Model class to transform properties between C# backend schema (camelCase/PascalCase)
// and the React frontend UI scheme (casing suffixes like ID, Dttm).
// -----------------------------------------------------------------------------

export class TicketModel {
  static toFrontend(data) {
    if (!data) return null;
    return {
      ticketID: data.ticketId || data.ticketID,
      ticketNumber: data.ticketNumber,
      projectID: data.projectId || data.projectID,
      phaseID: data.phaseId || data.phaseID,
      ticketTypeID: data.ticketTypeId || data.ticketTypeID,
      ticketSubTypeID: data.ticketSubTypeId || data.ticketSubTypeID,
      title: data.title,
      description: data.description,
      detailedDescription: data.detailedDescription,
      severityID: data.severityId || data.severityID,
      statusID: data.statusId || data.statusID,
      environmentID: data.environmentId || data.environmentID,
      raisedBy: data.raisedBy,
      clientOrgID: data.clientOrgId || data.clientOrgID,
      reopenReasonID: data.reopenReasonId || data.reopenReasonID,
      reopenCount: data.reopenCount || 0,
      createDate: data.createDate || data.createdDate || data.createDttm,
      resolvedDate: data.resolvedDate,
      lastUpdateDttm: data.lastUpdateDttm,
      lastUpdatedBy: data.lastUpdatedBy,
    };
  }

  static toBackend(data) {
    if (!data) return null;
    const projId = data.projectID ?? data.projectId;
    const phaseId = data.phaseID ?? data.phaseId;
    const typeId = data.ticketTypeID ?? data.ticketTypeId;
    const sevId = data.severityID ?? data.severityId;
    const statId = data.statusID ?? data.statusId;

    return {
      ticketId: Number(data.ticketID || data.ticketId || 0),
      ticketNumber: data.ticketNumber || '',
      projectId: projId !== undefined && projId !== null ? Number(projId) : 0,
      phaseId: phaseId !== undefined && phaseId !== null ? Number(phaseId) : 0,
      ticketTypeId: typeId !== undefined && typeId !== null ? Number(typeId) : 0,
      ticketSubTypeId: data.ticketSubTypeID || data.ticketSubTypeId ? Number(data.ticketSubTypeID || data.ticketSubTypeId) : null,
      title: data.title || '',
      description: data.description || '',
      detailedDescription: data.detailedDescription || '',
      severityId: sevId !== undefined && sevId !== null ? Number(sevId) : 1,
      statusId: statId !== undefined && statId !== null ? Number(statId) : 1,
      environmentId: data.environmentID || data.environmentId ? Number(data.environmentID || data.environmentId) : null,
      raisedBy: data.raisedBy ? Number(data.raisedBy) : 1,
      clientOrgId: data.clientOrgID || data.clientOrgId ? Number(data.clientOrgID || data.clientOrgId) : null,
      reopenReasonId: data.reopenReasonID || data.reopenReasonId ? Number(data.reopenReasonID || data.reopenReasonId) : null,
      reopenCount: Number(data.reopenCount || 0),
      createDate: data.createDate || new Date().toISOString(),
      resolvedDate: (Number(statId) === 3 || Number(statId) === 4)
        ? (data.resolvedDate || new Date().toISOString())
        : (data.resolvedDate || null),
      lastUpdateDttm: new Date().toISOString(),
      lastUpdatedBy: data.lastUpdatedBy ? Number(data.lastUpdatedBy) : 1,
    };
  }
}
